
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    SearchBar: () => import("@/components/filtersbar/SearchBar.vue"),
    Sorter: () => import("@/components/filtersbar/Sorter.vue"),
    Position: () => import("@/components/filtersbar/Position.vue"),
    Location: () => import("@/components/filtersbar/Location.vue"),
    FiltersAlert: () => import("@/components/filtersbar/FiltersAlert.vue"),
  }
})
export default class FiltersBar extends Vue {
  @Prop(Number) offerNumber!: number;
  @Prop(Array) offers!: any;
  @Prop(Object) countFilter!: any;
  @Prop(String) selectedArea!: string;
  @Prop(String) position_word!: string;
  @Prop(Function) setSort!: any;
  @Prop(Function) setFilters!: any;
  @Prop(Array) filtersWord!: any;
  @Prop(Object) filterFields!: any;
  @Prop(Array) options!: any;
  showFilters = false;
  windowWidth = 0;
  experiences = [];

  async mounted() {
    // const response = await (this as any).$root._get("experience", {});
    // (this as any).experiences = response;
  }

  openFilters() {
    this.showFilters = true;
    this.$store.commit("scrollBody", true);
    let a: any = this.$children.find(children => {
      return (children as any).$options._componentTag === "SearchBar";
    });
    if (a) a.show();
  }
  closeFilters() {
    this.showFilters = false;
    this.$store.commit("scrollBody", false);
    let a: any = this.$children.find((children: any) => {
      return children.$options._componentTag === "SearchBar";
    });
    if (a) a.hide();
  }
  removeFilterItem(item: any) {
    this.$emit("removeFilterBar", item);
  }
  openCreateAccount() {
    let a: any = this.$children.find((children: any) => {
      return children.$options._componentTag === "CreateAcountModalForm.vue";
    });
    if (a) a.showModal();
  }
  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }
  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
  changeLocation(value: any, $refs: any) {
    (this as any).setFilters({
      name: value.label,
      tag: "location",
      value: value.id
    });
    $refs.location.hide();
    this.$emit("selectLocation", event);
  }
  changeSelect(event: any, $refs: any) {
    (this as any).setFilters({
      name: event.name,
      tag: "area",
      value: event.value
    });
    $refs.position.hide();
    this.$emit("selectArea", event);
  }
  addWord(event: any, $refs: any) {
    if (event.keyCode === 13) {
      (this as any).setFilters({ name: event.target.value, tag: "word" });
      $refs.position.hide();
      this.$emit("setWord", event);
    }
  }
}
